declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";

import { Router, ActivatedRoute, Params } from '@angular/router';

import * as alertFunctions from '../../../../shared/data/sweet-alerts';


declare var require: any;

import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
import { NgbModal, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import { routerTransition } from '../../../../../../src/app/ncs/animations/router.animations';
import { NgbAddBill } from './modal/addbill.modal';
import { NgbPayBillModal } from './paybill.modal';
import {
  PatientInfoByFormattedCodeController, ServicesByCategoryCodeController, ServicesByCategoryCodeRequest, NewBillData, SaveBillItemsInfoRequest, DoctorsListController, DoctorsListRequest, X_BillHeaderController, X_BillItemsController, X_BillReceiptsController, x_BillDetailsRequest, BillDetailsInfoController, SaveBillItemsInfoRequest2, GenericProcPostRequest, S_Methods,
  X_BillHeaderByProviderCodeController, X_BillItemsByProviderCodeController, X_BillReceiptsByProviderCodeController, x_BillDetailsByProviderCodeRequest, BillDetailsByProviderCodeInfoController
} from '../../../../../../src/app/ncs/models/actor/actor';
import { PatientInfoByFormattedCodeRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
import { NGXToastrService } from '../../../../../../src/app/shared/services/toastr.service';
import { Servicebillpipe } from '../../../pipes/actors/actorIdentity.pipes';
import { NgbPaymentModal } from './modal/payment.modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { PrintService } from '../../../../../../src/app/ncs/services/print.service';
import { NgbSearchProviderModal } from '../ivf/ivfworkbench/searchprovider.modal';
import { NgbAddDiscountModal } from './modal/adddiscount.modal';
import { NgbAddNewServiceModal } from '../profile/patientprofileview/personaldetailview/modal/addnewservice.modal';
import { NgbOPSearchProviderModal } from '../follow up/counsellingregistry/modal/opsearchprovider.modal';
import { I18NHtmlParser } from '@angular/compiler';
import { PrescribingDoctor, ReferringDoctor, BillDetails, BillItemDeleted } from '../_MasterClasses/BillingClasses';




@Component({
  selector: 'receiptold',
  templateUrl: './receiptold.component.html',
  styleUrls: ['./receiptold.component.scss']
  , animations: [routerTransition()]
})

export class ReceiptOldComponent implements OnInit {


  public ApiResData: ApiResponseModel;
  @Input() FormattedCode: string;
  @Input() public FromScreen: string = "NONE";
  @Input() FormattedCode2: string;
  @Input() public marginTop: number = 10;
  public ActorCode: number = 0;
  //public FormattedCode: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public Showarrow: boolean = false;
  public ShowList: boolean = true;
  public ShowPatientDetails: boolean = false;
  public receipt: boolean = true;
  public opbilling: boolean = false;
  public Add: boolean = true;
  public Edit: boolean = false;
  public LChargeEntryCode: number = 0;
  public Tdiscount: number;
  public selectedGroup: any;
  public istextshowq: boolean = false;
  public istextshowu: boolean = false;
  public istextshowd: boolean = false;
  // public Tdiscount: number = 0;
  public isRequesting: boolean = false;
  public PrescriberData: PrescribingDoctor[];
  public ReferalData: ReferringDoctor[];
  public cash: boolean = false;
  public card: boolean = false;
  public cheque: boolean = false;
  public demanddraft: boolean = false;
  public paytm: boolean = false;
  public FormattedCodedata: any;
  public DiscountRemarks: string;
  public Prescribername: any;
  public Prescribercode: number = 0;
  public Prescriberdesg: any;
  public Refname: any = "";
  public Refcode: number = 0;
  public Prevdisconut: number = 0;
  public Todaydisc: number = 0;
  public DiscountMode: string;
  public Refdesg: any = "";
  public Referalname: any;
  public ReferalCode: any;
  public Referaldesg: any;
  public TotalBill: number;
  public NetPayable: number;
  public isvisible: boolean = true;
  public BranchName: string;
  public Date: Date;
  public ChargeEntryCodeModal: number = 0;
  searchTitle: string;
  // public SelectedPrescriber: PrescribingDoctor[];
  //public SelectedReferral: ReferringDoctor[];
  CurrentSaveBillItemsInfoRequest: SaveBillItemsInfoRequest;
  CurrentSaveBillItemsInfoRequest2: SaveBillItemsInfoRequest2;
  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  SelectedPatientFormattedCode: PatientInfoByFormattedCodeController;
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;



  LoadPatients(FormattedCode: string) {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();

    //alert('Checking Forma ' + this.FormattedCode);



    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = FormattedCode;
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";
    this.GetPatientInfoByFormattedCodeController();
  }
  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();


    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          this.SelectedPatientFormattedCode = this.CurrentPatientInfoByFormattedCodeController[0];
          if (this.SelectedPatientFormattedCode.PrimaryDoctor == 'null' || this.SelectedPatientFormattedCode.PrimaryDoctor == '---') {

            this.LoadServicesByCategory(this.Prescribercode);
          }
          this.LoadDoctorsList();
          //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          //this.LoadSign();
          //this.LoadPatientCounsellingPlansIfAny();



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  constructor(private router: Router,
    private actorservice: ActorService,
    public printService: PrintService,
    private route: ActivatedRoute, private loaderService: SpinnerService,
    private modalService: NgbModal,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,
    private filter: Servicebillpipe, private spinner: NgxSpinnerService


  ) { }

  ngOnInit() {
    this.DiscountMode = AppData.Instance().GetDataParam('Discount Mode');
    this.Prevdisconut = 0;
    //this.DiscountMode = 'Bill Level';
    //this.DiscountMode = AppData.Instance().GetDataParam('Discount Mode');
    //alert(this.DiscountMode);
    this.Tdiscount = 0;
    this.FormattedCodedata = this.route.snapshot.paramMap.get('FormattedCode');
    //this.route.queryParams
    //    .subscribe(params => {
    //        this.Prescribername = params.PrescriberName;
    //        this.FormattedCodedata = params.FormattedCodedata;
    //        this.Prescribercode = params.PrescriberCode;
    //        this.Prescriberdesg = params.Prescriberdesignation;
    //        this.Referalname = params.RefName;
    //        this.ReferalCode = params.RefCode;
    //        this.Referaldesg = params.Refdesignation;

    //    }
    //    );
    //alert(this.Prescribercode);
    if (this.FromScreen == 'NONE') {
      this.LoadPatients(this.FormattedCodedata);
    }
    else if (this.FromScreen == 'CommonBilling') {
      this.LoadPatients(this.FormattedCode2);
    }
    //this.LoadPatients(this.FormattedCodedata);
    //this.Prescribercode = 0;      

    //this.LoadDoctorPres();
    //this.LoadDoctorRef();
    this.CurrentSaveBillItemsInfoRequest = new SaveBillItemsInfoRequest();
    this.CurrentSaveBillItemsInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveBillItemsInfoRequest2 = new SaveBillItemsInfoRequest2();
    this.CurrentSaveBillItemsInfoRequest2.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  }

  CurrentServicesByCategoryCodeGetRequest: ServicesByCategoryCodeRequest;
  CurrentServicesByCategoryCodeController: ServicesByCategoryCodeController[];
  LoadServicesByCategory(Presecribercode: number) {

    this.CurrentServicesByCategoryCodeGetRequest = new ServicesByCategoryCodeRequest();
    //this.pdata2 = this.ServicesByCategoryCodeController;
    this.CurrentServicesByCategoryCodeGetRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentServicesByCategoryCodeGetRequest.ServiceCategory = "0";
    this.CurrentServicesByCategoryCodeGetRequest.BranchCode = AppData.Instance().SelectedBranchCode;
    this.CurrentServicesByCategoryCodeGetRequest.ConditionalOperator = 10;
    this.CurrentServicesByCategoryCodeGetRequest.PrescriberCode = Presecribercode;
    this.CurrentServicesByCategoryCodeController = new Array<ServicesByCategoryCodeController>();
    this.pdata = this.CurrentServicesByCategoryCodeController;
    this.GetServicesByCategoryCodeController();

  }
  GetServicesByCategoryCodeController() {
    this.StartRefreshing();
    this.spinner.show();
    this.actorservice.GetServicesByCategoryCodeController(this.CurrentServicesByCategoryCodeGetRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        //alert(this.ApiResData.ErrorData);
        if (!this.ApiResData.hasError) {

          this.CurrentServicesByCategoryCodeController = this.ApiResData.Result;
          this.pdata = this.CurrentServicesByCategoryCodeController;

          this.stopRefreshing();
          this.spinner.hide();
        }
        else {
          this.stopRefreshing();
          this.spinner.hide();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
            this.spinner.hide();


          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
            this.spinner.hide();
          }
        }


      );

  }
  CurrentDoctorsListController: DoctorsListController[];
  CurrentDoctorsListRequest: DoctorsListRequest;

  LoadDoctorsList() {
    this.CurrentDoctorsListController = new Array<DoctorsListController>();

    this.CurrentDoctorsListRequest = new DoctorsListRequest();
    // this.pdata = this.CurrentDoctorsListController;
    //this.pdata1 = this.CurrentDoctorsListController;
    this.CurrentDoctorsListRequest.ConditionalOperator = 20;
    this.CurrentDoctorsListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentDoctorsListRequest.ProvidersSpecality = "";
    this.CurrentDoctorsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDoctorsListController();
  }
  GetDoctorsListController() {
    this.StartRefreshing();

    this.actorservice.GetDoctorsListController(this.CurrentDoctorsListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //alert();
          this.CurrentDoctorsListController = this.ApiResData.Result;
          if (this.SelectedPatientFormattedCode.PrimaryDoctor != 'null') {
            var doc = this.CurrentDoctorsListController.filter(X => X.DisplayName == this.SelectedPatientFormattedCode.PrimaryDoctor);
            if (doc.length > 0) {
              this.Prescribercode = doc[0].ProviderCode;
              this.Prescriberdesg = doc[0].Specialty;
              this.Prescribername = this.SelectedPatientFormattedCode.PrimaryDoctor;
              ///this.LoadServicesByCategory(this.Prescribercode);
              this.LoadDoctorPres();
            }
          }
          if (this.SelectedPatientFormattedCode.RefDetails != 'null') {
            this.CurrentReferringDoctor = null;
            this.Refcode = this.SelectedPatientFormattedCode.RefCode;
            this.Refdesg = this.CurrentDoctorsListController.filter(X => X.DisplayName == this.SelectedPatientFormattedCode.RefDetails)[0].Specialty;
            this.Refname = this.SelectedPatientFormattedCode.RefDetails;
            this.LoadDoctorRef();
          }
          if (this.SelectedPatientFormattedCode.RefDetails == 'null') {
            // this.CurrentReferringDoctor = null;
            this.Refcode = 0;
            this.Refdesg = "null";
            this.Refname = "null";
            this.LoadDoctorRef();
          }

          //this.pdata = this.CurrentDoctorsListController;
          //this.pdata1 = this.CurrentDoctorsListController;
          //alert(this.CurrentServiceCategoriesController.length);

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  selectedGroupnew: PrescribingDoctor;
  onChange(Event: any) {
    //alert(Event.value);
    if (Event != null) {
      var a = this.CurrentDoctorsListController.filter(X => X.ProviderCode == Event.value)
      //alert(a.length);
      if (a.length > 0) {
        this.CurrentPrescribingDoctor = null;
        this.CurrentReferringDoctor = null;
        this.Prescribername = a[0].DisplayName;
        this.Prescribercode = a[0].ProviderCode;
        this.Prescriberdesg = a[0].Specialty;
        this.LoadDoctorPres();
        this.LoadDoctorRef();
        //this.LoadServicesByCategory(this.Prescribercode);
        //alert(this.Prescribername);

        //        // alert(this.ActivityDate);
      }
    }
  }
  CurrentPrescribingDoctor: Array<PrescribingDoctor>;
  LoadDoctorPres() {
    // alert(Selectedgroupnew.DoctorName + "," + Selectedgroupnew.DoctorCode);
    if (this.CurrentPrescribingDoctor == null) {
      this.CurrentPrescribingDoctor = new Array<PrescribingDoctor>();
    }
    if (this.CurrentPrescribingDoctor != null) {
      var row = new PrescribingDoctor();
      row.DoctorName = this.Prescribername;
      row.DoctorCode = this.Prescribercode;
      row.Designation = this.Prescriberdesg;
      //row.DoctorName = Selectedgroupnew.DoctorName;
      // row.DoctorCode = Selectedgroupnew.DoctorCode;
      // row.Designation = Selectedgroupnew.Designation;
      this.CurrentPrescribingDoctor.push(row);
    }
  }

  CurrentReferringDoctor: Array<ReferringDoctor>;

  LoadDoctorRef() {
    if (this.CurrentReferringDoctor == null) {
      this.CurrentReferringDoctor = new Array<ReferringDoctor>();
    }
    if (this.CurrentReferringDoctor != null) {
      var row = new ReferringDoctor();
      row.DoctorName = this.Refname;
      row.DoctorCode = this.Refcode;
      row.Designation = this.Refdesg;
      this.CurrentReferringDoctor.push(row);
    }
  }

  BackToProfile() {
    this.ShowList = true;
    this.ShowPatientDetails = false;
    this.Showarrow = false;
  }
  cashdata() {
    this.cash = true;
  }
  carddata() {
    this.card = true;
  }
  chequedata() {
    this.cheque = true;
  }
  demanddraftdata() {
    this.demanddraft = true;
  }
  paytmdata() {
    this.paytm = true;
  }
  pdata: any[];// = this.data;
  listFilter: string;
  ngOnChanges(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata = this.CurrentServicesByCategoryCodeController;

    this.criteriaChange(this.listFilter);
  }
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        //alert(this.listFilter);
        this.pdata = this.filter.transform(this.CurrentServicesByCategoryCodeController,
          this.listFilter);
      }
    }
  }

  clearData() {
    this.isNew = true;
    this.ShowList = false;

  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }

  RemoveServiceProvider(l: BillDetails) {
    l.ProviderCode = null;
    l.ProviderName = null;
    l.UnitPrice = l.BranchBasePrice;
    this.TotalBill = this.CurrentBillDetails.filter((l) => l.ItemRate)
      .map((l) => +l.ItemRate)
      .reduce((sum, current) => sum + current);
    //l.rDiscount = l.Quantity * l.UnitPrice * (l.Discount / 100);
    //this.Tdiscount = this.CurrentBillDetails.filter(l => l.rDiscount)
    //  .reduce((sum, current) => sum + current.rDiscount, 0);
    this.NetPayable = this.TotalBill - this.Tdiscount;
  }
  public ProviderName: string;
  public ProviderCode: number;
  public ProviderCost: number;
  public ProviderPrice: boolean = false;
  public UnitPriceOld: boolean = true;
  ServiceProvider(l: BillDetails) {
    const modalRef = this.modalService.open(NgbOPSearchProviderModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.CurrentBillDetails = l;
    //l.ProviderCode = 10;
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      l.ProviderName = receivedEntry.make;
      l.ProviderCode = receivedEntry.value;
      l.UnitPrice = receivedEntry.number;
      //alert(l.ProviderName);
      this.TotalBill = this.CurrentBillDetails.filter((l) => l.UnitPrice)
        .map((l) => +l.UnitPrice)
        .reduce((sum, current) => sum + current);
      //alert(this.TotalBill);
      //l.rDiscount = l.Quantity * l.UnitPrice * (l.Discount / 100);
      
      //this.Tdiscount = this.CurrentBillDetails.filter(l => l.rDiscount)
      //  .reduce((sum, current) => sum + current.rDiscount, 0);
      //alert(this.Tdiscount);
      this.NetPayable = this.TotalBill - this.Tdiscount;
      //alert(this.NetPayable);
      //alert(modalRef.componentInstance.CurrentBillDetails.)
    })
  }
  docedit() {
    //this.PrimaryDoctorO = false;
    //this.PrimaryDoctorn = true;

    const modalRef = this.modalService.open(NgbSearchProviderModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.IsShowDoctor = true;
    modalRef.componentInstance.DoctorType = 'All';
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.Prescribername = receivedEntry.make;
      this.Prescribercode = receivedEntry.value;
      this.Prescriberdesg = receivedEntry.desg;
      this.CurrentPrescribingDoctor = null;
      this.LoadDoctorPres();

      // this.Refcode = this.SelectedPatientFormattedCode.RefCode;
      //this.Refdesg = this.CurrentDoctorsListController.filter(X => X.DisplayName == this.SelectedPatientFormattedCode.RefDetails)[0].Specialty;
      //this.Refname = this.SelectedPatientFormattedCode.RefDetails;
      //this.LoadDoctorRef();

      //this.PrimaryNumber = receivedEntry.number;
      // this.CurrentSavePatientInfoRequest.PrimaryDoctor = this.PrimaryDoctor;
      //alert(this.ProviderName);
    })
  }
  //docedit() {

  //    const modalRef = this.modalService.open(NgbAddBill,
  //        {
  //            centered: true,
  //            size: "lg",
  //            backdrop: 'static',
  //            keyboard: false
  //        })
  //    modalRef.componentInstance.FormattedCode = this.FormattedCodedata;
  //    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
  //        this.SelectedPrescriber = receivedEntry.make;
  //        this.SelectedReferral = receivedEntry.value;

  //       alert(this.ProvidedName);
  //    })


  //}
  CancelNewOperation() {

    this.ShowList = true;
  }
  RefreshServices() {
    this.LoadServicesByCategory(this.Prescribercode);
  }
  AddNewService() {
    const modalRef = this.modalService.open(NgbAddNewServiceModal,
      {
        centered: true,
        size: "lg",
        backdrop: 'static',
        keyboard: false
      })
  }
  back() {
    this.receipt = false;
    this.opbilling = true;
    this.router.navigate(['/healins/opbilling']);
    //this.router.navigate.['/healins/opbilling'];
  }
  payment() {
    const modalRef = this.modalService.open(NgbPayBillModal,
      {
        centered: true,
        size: "lg"
      })
  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  CurrentBillDetails: Array<BillDetails>;
  AddRow(l: ServicesByCategoryCodeController) {
    if (this.CurrentBillDetails == null) {
      this.CurrentBillDetails = new Array<BillDetails>();
    }

    // what if same service item needs to be added multiple times..
    // such as consulation for doctor 1 , and consultation for doctor 2
    // Hoow about:
    /// show alert " You are adding the same item again.. would  you like to continue?
    // if yes.. allow to add
   // if no.. skip adding item as below code does.
    var itemExists = this.CurrentBillDetails.find(x => x.ServiceDescription == l.ServiceName);
    if (itemExists != null) {
      // no need to add again..!
      //this.CurrentBillDetails.push(item);
      return;
    }
    var item = this.deletedBillDetails.find(x => x.ServiceDescription == l.ServiceName);
    if (item != null) {
      this.CurrentBillDetails.push(item);
      this.deletedBillDetails.splice(this.deletedBillDetails.findIndex(x => x.ServiceDescription == l.ServiceName), 1);
    }
    else {
      var row = new BillDetails();      
      row.ChargeItemID = uuidv4();
 //     alert(row.ChargeItemID);
      row.Edit = false;
      row.RowNumber = row.RowNumber + 1;
      row.ServiceDescription = l.ServiceName;
      row.Quantity = 1;
      row.Discount = 0;
      row.ItemCode = l.Code;
      row.UnitPrice = l.BasePrice;
      row.BranchBasePrice = l.BasePrice;
      row.ItemRate = l.BasePrice * row.Quantity;
      row.GroupName = l.Servicecategory;
      row.PackageName = l.CategoryName;
      row.DiscountAllowed = l.DiscountAllowed;
      row.ChargeItemCode = 0;
      row.EditableCharge = l.EditableCharge;
      row.ProviderName = this.ProviderName;
      row.ProviderCode = this.ProviderCode;
      this.CurrentBillDetails.push(row);
    }

    this.TotalBill = this.CurrentBillDetails.filter((item) => item.UnitPrice)
      .map((item) => +item.UnitPrice)
      .reduce((sum, current) => sum + current);

    this.NetPayable = this.CurrentBillDetails.filter((item) => item.UnitPrice)
      .map((item) => +item.UnitPrice)
      .reduce((sum, current) => sum + current) - this.Tdiscount;
    this.BranchName = AppData.Instance().SelectedBranchName;
    this.Date = new Date();
    //        alert(l.BasePrice);

    //this.AddData();

  }
  CurrentNewBillData: NewBillData;
  AddData() {
    this.CurrentNewBillData = new NewBillData();
    this.CurrentNewBillData.ActorCode = this.SelectedPatientFormattedCode.ActorCode;


    this.CurrentNewBillData.BillDate = new Date();
    this.CurrentNewBillData.BillSource = "Internal";
    this.CurrentNewBillData.BillStatus = "";
    this.CurrentNewBillData.BillType = "OP";
    this.CurrentNewBillData.BranchCode = AppData.Instance().SelectedBranchCode;
    this.CurrentNewBillData.BranchName = AppData.Instance().SelectedBranchName;
    this.CurrentNewBillData.ChargeEntryCode = this.LChargeEntryCode;
    this.CurrentNewBillData.Gender = this.SelectedPatientFormattedCode.Gender;
    this.CurrentNewBillData.Items = this.CurrentBillDetails;
    this.CurrentNewBillData.DeletedItems = this.deletedBillDetails;
    this.CurrentNewBillData.PrescriberDoctor = this.CurrentPrescribingDoctor;
    this.CurrentNewBillData.ReferringDoctor = this.CurrentReferringDoctor;
    this.CurrentNewBillData.PatientFormattedCode = this.SelectedPatientFormattedCode.FormattedCode;
    this.CurrentNewBillData.PatientName = this.SelectedPatientFormattedCode.DisplayName;
    this.CurrentNewBillData.PhoneNumber = this.SelectedPatientFormattedCode.Telephone1;
    this.CurrentNewBillData.TotalDiscount = this.Tdiscount;
    this.CurrentNewBillData.PreviousDiscount = this.Prevdisconut;
    this.CurrentNewBillData.DiscountAmount = this.Todaydisc;
    this.CurrentNewBillData.DiscountRemarks = this.DiscountRemarks;
    this.CurrentNewBillData.Discountmode = this.DiscountMode;
    this.CurrentNewBillData.TotalBill = Math.round(this.CurrentBillDetails.filter((item) => item.UnitPrice)
      .map((item) => +item.UnitPrice)
      .reduce((sum, current) => sum + current));
    this.CurrentNewBillData.NetPayable = Math.round(this.CurrentBillDetails.filter((item) => item.UnitPrice)
      .map((item) => +item.UnitPrice)
      .reduce((sum, current) => sum + current) - this.Tdiscount);
    //this.CurrentNewBillData
   this.SaveData();
    //this.SaveData2();

  }
  SaveData() {
    this.isvisible = false;
    this.CurrentSaveBillItemsInfoRequest.Bill = this.CurrentNewBillData;
    this.CurrentSaveBillItemsInfoRequest.ChargeEntry = this.LChargeEntryCode.toString();
    this.CurrentSaveBillItemsInfoRequest.ConditionalOperator = 10;
    this.actorservice.SaveBillItemsInfo(this.CurrentSaveBillItemsInfoRequest)
      .subscribe((result) => {

        this.ApiResData = result;
        if (result.Result[0].Result > 0) {
          //if (!this.ApiResData.hasError) {

          //   if (this.ApiResData.Result > 0) {
          this.LChargeEntryCode = this.ApiResData.Result[0].Result;
          // alert(this.LChargeEntryCode);
          //this.GetActorEducationInfoController();
          //this.GetResourceIdentificationByDateInfoController();
          // alertFunctions.AlertParam('Saved Successfully.....!');
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.isvisible = true;
          // this.Listview = true;
          //this.EditEmbryo = false;
          //this.LoadStoreData();
          //this.AddEmbryo = false;
          //this.spinner.hide();
          //this.activeModal.close();
          //this.clearData();
          // this.LoadScansData();
          this.stopRefreshing();

          //this.spinner.hide();
        }
        else {
          alertFunctions.AlertParam("Invalid Operation :- " + "...!");

          //this.spinner.hide();
          this.stopRefreshing();
          //this.spinner.hide();
          this.isvisible = true;
        }

      },





        (error) => {
          // alert("kkhkhjkhkjhjkh");

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.isvisible = true;
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.isvisible = true;
            this.stopRefreshing();
          }
        }
      );
  }
  public LChargeEntryCode2: string;
  SaveData2() {
    this.isvisible = false;
    var saveReq = new SaveBillItemsInfoRequest2();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40112;
    saveReq.Bill = this.CurrentNewBillData;
    //saveReq.ChargeEntry = this.LChargeEntryCode.toString();
    //alert(this.LChargeEntryCode);
    if (this.LChargeEntryCode != null)
      saveReq.ChargeEntry = this.LChargeEntryCode.toString();
    else
      saveReq.ChargeEntry = '0';
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40112;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            //alert(this.ApiResData);
            //alert(this.ApiResData.Result);
            //alert(this.ApiResData.Result[0]);
          //  alert(this.ApiResData.Result[0].Result);

            this.LChargeEntryCode = parseInt(this.ApiResData.Result[0]);
            //alert(this.LChargeEntryCode);
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.isvisible = true;
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
            this.isvisible = true;
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            //this.spinner.hide();
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.isvisible = true;
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);
            this.isvisible = true;
            this.stopRefreshing();
          }
        }
      );
  }
  Itemchange(l: BillDetails) {

    if (l.UnitPrice < 0) {
      this.isvisible = false;
      this.istextshowu = true;
    }
    else if (l.UnitPrice == 0 || l.UnitPrice > 0) {
      this.isvisible = true;
      this.istextshowu = false;
    }
    l.ItemRate = l.Quantity * l.UnitPrice;
    this.TotalBill = this.CurrentBillDetails.filter((l) => l.ItemRate)
      .map((l) => +l.ItemRate)
      .reduce((sum, current) => sum + current);
    //l.rDiscount = l.Quantity * l.UnitPrice * (l.Discount / 100);
    //this.Tdiscount = this.CurrentBillDetails.filter(l => l.rDiscount)
    //  .reduce((sum, current) => sum + current.rDiscount, 0);
    this.NetPayable = this.TotalBill - this.Tdiscount;
  }
  Qunatitychange(l: BillDetails) {
    l.ItemRate = l.Quantity * l.UnitPrice;
    this.TotalBill = this.CurrentBillDetails.filter((l) => l.ItemRate)
      .map((l) => +l.ItemRate)
      .reduce((sum, current) => sum + current);
    //l.rDiscount = l.Quantity * l.UnitPrice * (l.Discount / 100);
    //this.Tdiscount = this.CurrentBillDetails.filter(l => l.rDiscount)
    //  .reduce((sum, current) => sum + current.rDiscount, 0);
    this.NetPayable = this.TotalBill - this.Tdiscount;
  }
  Discountchange(l: BillDetails) {

    if (l.Discount < 0) {
      this.isvisible = false;
    }
    else if (l.Discount > 100) {
      this.isvisible = false;
    }
    else if (l.Discount == 0 || l.Discount < 100) {
      this.isvisible = true;
    }
    l.rDiscount = l.Quantity * l.UnitPrice * (l.Discount / 100);

    //this.Tdiscount = this.CurrentBillDetails.filter((l) => l.rDiscount)
    //.map((l) => +l.rDiscount)
    //  .reduce((sum, current) => sum + current);
    this.Tdiscount = this.CurrentBillDetails.filter(l => l.rDiscount)
      .reduce((sum, current) => sum + current.rDiscount, 0);
    this.NetPayable = this.TotalBill - this.Tdiscount;
  }

  //alert(this.CurrentBillDetails.length);
  // CurrentBillDetailsEdit: BillDetails;
  Editrow(l: BillDetails) {
    //this.Add = false;

    //this.Edit = true;
    l.Edit = true;
    //this.CurrentBillDetailsEdit = new BillDetails();
    //this.CurrentBillDetailsEdit.rownumber = l.rownumber;
    //this.CurrentBillDetailsEdit.ServiceDescription = l.ServiceDescription;
    //this.CurrentBillDetailsEdit.quantity = l.quantity;
    //this.CurrentBillDetailsEdit.unitprice = l.unitprice;
    //this.CurrentBillDetailsEdit.discount = l.discount;
    //this.CurrentBillDetailsEdit.ItemRate = l.ItemRate;

  }
  deletedBillDetails: Array<BillDetails> = new Array<BillDetails>();
  delete(i: number, l: BillDetails) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false
    }).then(() => {

      this.deleterow(i, l);

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })

  }
  deleterow(i: number, l: BillDetails) {
    this.CurrentBillDetails.splice(i, 1);
    this.TotalBill = this.CurrentBillDetails.filter(item => item.ItemRate)
      .reduce((sum, current) => sum + current.ItemRate, 0);
    this.Tdiscount = this.CurrentBillDetails.filter(item => item.rDiscount)
      .reduce((sum, current) => sum + current.rDiscount, 0);
    this.NetPayable = this.TotalBill - this.Tdiscount;
    if (this.LChargeEntryCode > 0) {
      if (this.deletedBillDetails != null) {
        var row = new BillDetails();
        row.ChargeItemID = l.ChargeItemID;
        row.Edit = false;
        
        row.RowNumber = row.RowNumber + 1;
        row.ServiceDescription = l.ServiceDescription;
        row.Quantity = l.Quantity;
        row.Discount = l.Discount;
        row.ItemCode = l.ItemCode;
        row.UnitPrice = l.UnitPrice;
        row.ItemRate = l.UnitPrice * l.Quantity;
        row.GroupName = l.GroupName;
        row.PackageName = l.PackageName;
        row.DiscountAllowed = l.DiscountAllowed;
        row.ChargeItemCode = 0;
        row.ProviderName = l.ProviderName;
        row.ProviderCode = l.ProviderCode;
        this.deletedBillDetails.push(row);
      }

    }
  }
  AddDiscount() {
    const modalRef = this.modalService.open(NgbAddDiscountModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.PreviousDiscount = this.Prevdisconut;
    modalRef.componentInstance.TotalBill = this.TotalBill;
    modalRef.componentInstance.TodaysDiscount = this.Todaydisc;
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.Tdiscount = receivedEntry.value;
      this.Todaydisc = receivedEntry.make;
      this.DiscountRemarks = receivedEntry.Remarks;
      this.NetPayable = this.TotalBill - this.Tdiscount;
    })
  }
  OnClear(l: BillDetails) {
    l.Edit = false;
  }
  Payment() {
    this.AddData();
    const modalRef = this.modalService.open(NgbPaymentModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.FormattedCode = this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode;
    modalRef.componentInstance.PatientImage = this.CurrentPatientInfoByFormattedCodeController[0].PatientImageFile;
    modalRef.componentInstance.PatientName = this.CurrentPatientInfoByFormattedCodeController[0].DisplayName;
    modalRef.componentInstance.Age = this.CurrentPatientInfoByFormattedCodeController[0].Age;
    modalRef.componentInstance.Gender = this.CurrentPatientInfoByFormattedCodeController[0].Gender;
    modalRef.componentInstance.Telephone1 = this.CurrentPatientInfoByFormattedCodeController[0].Telephone1;
    modalRef.componentInstance.BillDate = this.CurrentNewBillData.BillDate;
    modalRef.componentInstance.TotalBill = Math.round(this.TotalBill);
    modalRef.componentInstance.NetPayable = Math.round(this.NetPayable);
    modalRef.componentInstance.Discount = this.Tdiscount;
    //modalRef.componentInstance.TotalBill = Math.round(this.CurrentNewBillData.TotalBill);
    //modalRef.componentInstance.NetPayable = Math.round(this.CurrentNewBillData.NetPayable);
    //modalRef.componentInstance.Discount = this.CurrentNewBillData.TotalDiscount;
    modalRef.componentInstance.ActorCode = this.CurrentNewBillData.ActorCode;
    modalRef.componentInstance.ChargeEntryCode = this.LChargeEntryCode;
    modalRef.componentInstance.BillStatus = this.CurrentNewBillData.BillStatus;
    modalRef.componentInstance.BillType = this.CurrentNewBillData.BillType;
    modalRef.componentInstance.BillType2 = "OP";
    modalRef.componentInstance.BillSource = this.CurrentNewBillData.BillSource;
    modalRef.componentInstance.BranchName = this.CurrentNewBillData.BranchName;
    modalRef.componentInstance.BranchCode = this.CurrentNewBillData.BranchCode;
    modalRef.componentInstance.PatientCode = this.CurrentPatientInfoByFormattedCodeController[0].PatientRegistrationNumber;
    modalRef.componentInstance.ItemsSelected = this.CurrentBillDetails;
    modalRef.componentInstance.BillStatus2 = 'New';
    modalRef.componentInstance.DiscountMode = this.DiscountMode;
    modalRef.componentInstance.PreviousDiscount = this.Prevdisconut;
    modalRef.componentInstance.Discountre = this.DiscountRemarks;
    modalRef.componentInstance.Prescriber = this.CurrentPrescribingDoctor;
    modalRef.componentInstance.Refferal = this.CurrentReferringDoctor;
    modalRef.componentInstance.Data = 'Full';
    modalRef.result.then((val: number) => {
      this.ChargeEntryCodeModal = val;
      if (val > 0 && this.DiscountMode == 'Bill Level') {
        //this.LoadBillHeader(val);
        //this.GetBillHeader(val);
        this.LoadProviderBillHeader(val);
      }
    });

  }

  CurrentX_BillHeaderByProviderCodeController: X_BillHeaderByProviderCodeController;
  CurrentX_BillItemsByProviderCodeController: X_BillItemsByProviderCodeController[];
  CurrentX_BillReceiptsByProviderCodeController: X_BillReceiptsByProviderCodeController[];

  Currentx_BillDetailsByProviderCodeRequest: x_BillDetailsByProviderCodeRequest;

  ProviderBillDataHeader: BillDetailsByProviderCodeInfoController;

  LoadProviderBillHeader(ChargeEntryCode: number) {
    this.Currentx_BillDetailsByProviderCodeRequest = new x_BillDetailsByProviderCodeRequest();
    this.Currentx_BillDetailsByProviderCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetX_BillHeaderByProviderCodeController(ChargeEntryCode);
  }
  GetX_BillHeaderByProviderCodeController(ChargeEntry: number) {
    this.Currentx_BillDetailsByProviderCodeRequest.ChargeEntry = ChargeEntry;
    this.Currentx_BillDetailsByProviderCodeRequest.ConditionalOperator = 5;
    this.actorservice.GetBillDetailsByProviderCode(this.Currentx_BillDetailsByProviderCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.ProviderBillDataHeader = this.ApiResData.Result;
          this.CurrentX_BillHeaderByProviderCodeController = this.ProviderBillDataHeader.Header;
          this.CurrentX_BillItemsByProviderCodeController = this.ProviderBillDataHeader.Items;
          this.CurrentX_BillReceiptsByProviderCodeController = this.ProviderBillDataHeader.Receipts;
          this.TotalBill = this.ProviderBillDataHeader.Header.TotalAmount;
          this.NetPayable = this.ProviderBillDataHeader.Header.Net;
          this.Tdiscount = this.ProviderBillDataHeader.Header.Discount;
          this.AddData3();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  //CurrentX_BillHeaderController: X_BillHeaderController;
  //CurrentX_BillItemsController: X_BillItemsController[];
  //CurrentX_BillReceiptsController: X_BillReceiptsController[];
  //CurrentX_BillHeaderRequest: x_BillDetailsRequest;
  //BillDataHeader: BillDetailsInfoController;

  //LoadBillHeader(ChargeEntryCode: number) {
  //  this.CurrentX_BillHeaderRequest = new x_BillDetailsRequest();
  //  this.CurrentX_BillHeaderRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  this.GetX_BillHeaderController(ChargeEntryCode);
  //}

  //GetX_BillHeaderController(ChargeEntry: number) {
  //  this.CurrentX_BillHeaderRequest.ChargeEntry = ChargeEntry;
  //  this.CurrentX_BillHeaderRequest.ConditionalOperator = 5;
  //  this.actorservice.GetBillHeaderController(this.CurrentX_BillHeaderRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {
  //        this.BillDataHeader = this.ApiResData.Result;
  //        this.CurrentX_BillHeaderController = this.BillDataHeader.Header;
  //        this.CurrentX_BillItemsController = this.BillDataHeader.Items;
  //        this.CurrentX_BillReceiptsController = this.BillDataHeader.Receipts;
  //        this.TotalBill = this.BillDataHeader.Header.TotalAmount;
  //        this.NetPayable = this.BillDataHeader.Header.Net;
  //        this.Tdiscount = this.BillDataHeader.Header.Discount;
  //        this.AddData3();

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },

  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();
  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();
  //        }
  //      }
  //    );
  //}
  AddData3() {
    this.CurrentBillDetails = new Array<BillDetails>();
    this.CurrentX_BillItemsByProviderCodeController.forEach((v, i, d) => {
      var item = new BillDetails();
      item.ChargeItemID = v.ChargeItemID;
      item.Edit = false;
      item.RowNumber = item.RowNumber + 1;
      item.ServiceDescription = v.ItemDescription;
      item.Quantity = v.Quantity;
      item.Discount = v.Discount;
      item.UnitPrice = v.UnitPrice;
      item.ItemRate = v.ItemTotal;
      item.GroupName = v.ServiceCategory.toString();
      item.PackageName = v.ServiceCategoryName;
      item.DiscountAllowed = false;
      item.ChargeItemCode = v.ChargeItemCode;
      item.ItemCode = v.ItemCode;
      item.ProviderName = v.ProviderName;
      item.ProviderCode = v.ProviderCode;
      this.CurrentBillDetails.push(item);

    });
  }
  Cancel() {
    this.router.navigate(['healins/opbilling']);
  }
  Cancel2() {
    this.router.navigate(['healins/combinedbilling']);
  }
  opbill() {
    this.printService.printDocument2(this.SelectedPatientFormattedCode.FormattedCode, 0

    );
    this.printService.printDocument3(this.CurrentX_BillHeaderByProviderCodeController.BillNo, 0

    );
    this.printService.printDocument("opbill",
      {
        ChargeEntryData: this.LChargeEntryCode,
        PatientId: this.SelectedPatientFormattedCode.FormattedCode,
        Owner: this.SelectedPatientFormattedCode.DisplayName,
        Gender: this.SelectedPatientFormattedCode.Gender,
        Age: this.SelectedPatientFormattedCode.Age,
        BillDate: this.CurrentNewBillData.BillDate,
        BillNo: this.CurrentX_BillHeaderByProviderCodeController.BillNo,
        Branch: this.CurrentNewBillData.BranchName,
        ReceiptFormattedCode: this.CurrentX_BillHeaderByProviderCodeController.ReceiptFormattedCode,
        GrandTotal: this.CurrentNewBillData.TotalBill,
        Discount: this.CurrentNewBillData.TotalDiscount,
        Tax: this.CurrentX_BillHeaderByProviderCodeController.Tax,
        Net: this.CurrentNewBillData.NetPayable,
        Due: this.CurrentX_BillHeaderByProviderCodeController.Balance,
        ReferralData: this.CurrentNewBillData.ReferringDoctor,

      },

    );
  }

}
//export class BillDetails {
//  public SequenceNo: number;
//  public ChargeItemID: string;
//  public ItemCode: number;
//  public ServiceDescription: string;
//  public Quantity: number;
//  public UnitPrice: number;
//  public BranchBasePrice: number;
//  public Discount: number;
//  public ItemRate: number;
//  public RowNumber: number;
//  public Edit: boolean;
//  public ServiceCode: number;
//  public ItemType: string;
//  public ItemGroup: string;
//  public GroupName: string;
//  public IsPackage: boolean;
//  public PackageName: string;
//  public ChargeItemCode: number;
//  public DiscountAllowed: boolean;
//  public rDiscount: number;
//  public CanModify: boolean;
//  public IsDeleted: boolean = false;  // editing purposes only... 
//  public EditableCharge: boolean;
//  public RefundableAmount: number;
//  public RefundableQuantity: number;
//  public TaxPercentage: number;
//  public ProviderCode: number;
//  public ProviderName: string;
//}

//export class BillItemDeleted {

//  public ChargeItemCode: number;
//}

//export class PrescribingDoctor {
//  public DoctorName: string;
//  public DoctorCode: number;
//  public Designation: string;
//}
//export class ReferringDoctor {
//  public DoctorName: string;
//  public DoctorCode: number;
//  public Designation: string;
//}

